export const HOMEPAGE_REQUEST = Symbol('HOMEPAGE_REQUEST');
export const HOMEPAGE_SET_IN_STORE = Symbol('HOMEPAGE_SET_IN_STORE');

/**
 * @param {CollectionModel.type[]} collections
 * @return {{
 *  type: Symbol,
 *  payload: {
 *    collections: CollectionModel.type[]
 *  }
 * }}
 */
export const homePageSetInStoreAction = (collections) => ({
  type: HOMEPAGE_SET_IN_STORE,
  payload: { collections },
});

/**
 * @return {{type: symbol}}
 */
export const homePageRequestAction = () => ({
  type: HOMEPAGE_REQUEST,
});
